/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const OfficeChairIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M11.5,21 L11.5,17.5" />
      <path d="M17.5,16.5 C17.5,17.054 17.053,17.5 16.5,17.5 L6.5,17.5 C5.948,17.5 5.5,17.054 5.5,16.5 L5.5,15 C5.5,14.449 5.948,14 6.5,14 C9.944,13.334 13.277,13.334 16.5,14 C17.053,14 17.5,14.449 17.5,15 L17.5,16.5 Z" />
      <polyline points="17.5 15.5 19.5 15.5 20.5 9.5" />
      <path d="M18.5,9.5 L22.5,9.5 C22.5,8.4 21.6,7.5 20.5,7.5 C19.4,7.5 18.5,8.4 18.5,9.5 Z" />
      <polyline points="5.5 15.5 3.5 15.5 2.5 9.5" />
      <path d="M4.5,9.5 L0.5,9.5 C0.5,8.4 1.4,7.5 2.5,7.5 C3.6,7.5 4.5,8.4 4.5,9.5 Z" />
      <path d="M8,13.5 C8,13.5 5.496,6.5 5.5,5.5 C5.51,3.004 7.822,0.786 10.453,0.547 C10.786,0.517 11.135,0.5 11.5,0.5 C11.865,0.5 12.214,0.517 12.547,0.547 C15.185,0.787 17.5,2.996 17.5,5.5 C17.5,6.5 15,13.5 15,13.5" />
      <circle cx="11.5" cy="22.5" r="1" />
      <circle cx="16.5" cy="22.5" r="1" />
      <circle cx="6.5" cy="22.5" r="1" />
      <path d="M6.5,21.5 C6.5,21.5 8,19.5 11.5,19.5 C15,19.5 16.5,21.5 16.5,21.5" />
    </g>
  </svg>
);

export default OfficeChairIcon;
